/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RequiresImages/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function RequiresImages({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Procedures/AddAction/Add/Content/RequiresImages",
  onChange
  
}) {
let procedureRequiresImagesValueData = fromData.useDataValue({ viewPath,
context: 'procedure',
path: 'requires_images',
})
let procedureRequiresImagesChangeData = fromData.useDataChange({ viewPath,
context: 'procedure',
path: 'requires_images',
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="procedure.requires_images"
 value={procedureRequiresImagesValueData}
 onChange={procedureRequiresImagesChangeData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Requires images"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}